// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bg_title[data-v-62c98345]{background:linear-gradient(87.99deg,#2b2493 -12.43%,#7546d9 117.72%)}.bg_title[data-v-62c98345],.rounded_custom[data-v-62c98345]{border-bottom-right-radius:400px 30px;border-bottom-left-radius:400px 30px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
